import { ISdColDef } from "../../baseColumn/BaseColumnTypes";
import { BASE_COLUMN_CONFIG } from "../../baseColumn/BaseColumn_config";

export const DYNAMIC_COLUMN_CONFIG = (columnOptions?: ISdColDef<any, any>): ISdColDef<any, any> => ({
  ...BASE_COLUMN_CONFIG,
  ...columnOptions
});
